import { getAnalytics } from '..';
import { OpenDialogPayload } from '../../pimster-dialog/pimster-dialog.types';
import { EVENTS } from '../constants';

export const trackOpen = (payload: OpenDialogPayload) => {
  const analytics = getAnalytics();
  analytics?.track(EVENTS.Open, payload);
};
